import IdentificationMethodContent from 'components/newAccountSteps/profileSteps/profileStep3/IdentificationMethod/constants/IdentificationMethodContent';
import {
    ROBO_IBAN,
    ROBO_TRANSFER,
    ROBO_VIDEOCALL,
    ROBO_VIDEOS,
    ROBO_VIDEOSELFIE,
    TC_IBAN,
    TC_VIDEOCALL,
    TC_VIDEOS,
    TC_VIDEOSELFIE,
    VIDEOCALLS_IN_1_BOX,
} from 'constants/featureFlagging';
import { COURIER, IBAN, TRANSFER_CERTIFICATE, VIDEO_CALL, VIDEO_SELFIE } from 'constants/identityMethod';

export const VIDEOSELFIE_METHODS_TYPES = {
    WITH_BIOMETRY: 'WITH_BIOMETRY',
    WITHOUT_BIOMETRY: 'WITHOUT_BIOMETRY',
};

const IDENTIFICATION_METHOD_MAPPER = {
    [TC_VIDEOS]: IdentificationMethodContent.videosContent,
    [VIDEOCALLS_IN_1_BOX]: IdentificationMethodContent.videosContent,
    [ROBO_VIDEOS]: IdentificationMethodContent.videosContent,

    [TC_VIDEOCALL]: IdentificationMethodContent.videoCallContent,
    [VIDEO_CALL]: IdentificationMethodContent.videoCallContent,
    [ROBO_VIDEOCALL]: IdentificationMethodContent.videoCallContent,

    [TC_VIDEOSELFIE]: IdentificationMethodContent.videoSelfieContent,
    [VIDEO_SELFIE]: {
        [VIDEOSELFIE_METHODS_TYPES.WITH_BIOMETRY]: IdentificationMethodContent.videoSelfieContent,
        [VIDEOSELFIE_METHODS_TYPES.WITHOUT_BIOMETRY]: IdentificationMethodContent.videoSelfieWithoutBiometricsContent,
    },
    [ROBO_VIDEOSELFIE]: IdentificationMethodContent.videoSelfieContent,

    [IBAN]: IdentificationMethodContent.ibanContent,
    [TC_IBAN]: IdentificationMethodContent.ibanContent,
    [ROBO_IBAN]: IdentificationMethodContent.ibanContent,

    [TRANSFER_CERTIFICATE]: IdentificationMethodContent.transferContent,
    [ROBO_TRANSFER]: IdentificationMethodContent.transferContent,
    [COURIER]: IdentificationMethodContent.courierContent,
};

export default IDENTIFICATION_METHOD_MAPPER;
